var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "cog-picker cog-input",
      class: { "is-read-only": _vm.readonly },
      on: { click: _vm.handleOuterClick }
    },
    [
      _vm.readonly
        ? [_vm._v(_vm._s(_vm.textValue || " "))]
        : _vm.chameleon || _vm.mobile
        ? _c(
            "c-picker-native",
            {
              attrs: {
                placeholder: _vm.placeholder,
                "show-placeholder": !_vm.chameleon && !_vm.value
              },
              scopedSlots: _vm._u(
                [
                  _vm.mobile
                    ? {
                        key: "icon",
                        fn: function() {
                          return [
                            _c("i-calendar", {
                              class: {
                                "cog-offscreen": _vm.dateTimeIconIsHidden
                              }
                            })
                          ]
                        },
                        proxy: true
                      }
                    : null
                ],
                null,
                true
              )
            },
            [
              _c(
                "input",
                _vm._b(
                  {
                    ref: "input",
                    staticClass: "el-input__inner",
                    attrs: {
                      id: _vm.fullId,
                      type: "date",
                      min: _vm.$format(_vm.min, "yyyy-MM-dd"),
                      max: _vm.$format(_vm.max, "yyyy-MM-dd"),
                      "aria-required": _vm.isRequired ? true : undefined,
                      "aria-describedby": _vm.hasError
                        ? `${_vm.fullId}-error`
                        : undefined,
                      "aria-invalid": _vm.hasError ? true : undefined
                    },
                    domProps: { value: _vm.nativeTextValue },
                    on: {
                      focus: _vm.handleFocus,
                      blur: _vm.handleBlur,
                      change: _vm.handleNativeChange
                    }
                  },
                  "input",
                  _vm.$attrs,
                  false
                )
              )
            ]
          )
        : _c(
            "c-date-picker",
            _vm._b(
              {
                ref: "picker",
                attrs: {
                  id: _vm.fullId,
                  value: _vm.dateValue,
                  "unparsed-value": _vm.unparsedValue,
                  format: _vm.elementFormat,
                  "model-format": _vm.modelFormat,
                  placeholder: _vm.placeholder,
                  "popper-class":
                    "cog-cognito cog-" +
                    _vm.scope +
                    " cog-cognito--" +
                    (_vm.chameleon ? "chameleon" : "styled") +
                    " cog-date-picker" +
                    (_vm.flags.protectCss ? " cog-cognito--protect-css" : ""),
                  "format-date": (date, format) => _vm.$format(date, format),
                  "parse-date": (text, format) =>
                    _vm.$parse(Date, text, format),
                  "default-value": _vm.defaultValue,
                  minimum: _vm.normalizedMin,
                  maximum: _vm.normalizedMax,
                  "picker-options": {
                    firstDayOfWeek: _vm.$culture.dateTimeFormat.FirstDayOfWeek
                  },
                  "aria-required": _vm.isRequired ? true : undefined,
                  "aria-describedby": _vm.hasError
                    ? `${_vm.fullId}-error`
                    : undefined,
                  "aria-invalid": _vm.hasError ? true : undefined
                },
                on: {
                  click: _vm.handleClick,
                  focus: _vm.handleFocus,
                  blur: _vm.handleBlur,
                  input: _vm.handleInput,
                  change: _vm.handleChange,
                  "visible-change": _vm.handlePickerVisibleChange,
                  pickerPosition: _vm.handlePreFocus
                },
                scopedSlots: _vm._u([
                  {
                    key: "suffix",
                    fn: function() {
                      return [
                        _c(
                          "span",
                          {
                            on: {
                              click: _vm.handleIconClick,
                              mousedown: _vm.handleIconMousedown
                            }
                          },
                          [_c("i-calendar")],
                          1
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              },
              "c-date-picker",
              _vm.$attrs,
              false
            )
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }